import { css } from 'styled-components';

export const maxWidths = {
  l: 1309,
  m: 1159,
  s: 809,
  xs: 629,
};

// >= 1309 (default)
// < 1309 && > 1159 (l)
// < 1150 && > 809 (m)
// < 809 && > 629 (s)
// < 629 (xs)

export const devices = {};

// FIXME - replace with map
// eslint-disable-next-line
for (const [size, max] of Object.entries(maxWidths)) {
  devices[size] = { max };
}

export const media = Object.entries(devices).reduce(
  (declarations, [label, sizes]) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const minEmSize = sizes.min && sizes.min / 16;
    const maxEmSize = sizes.max && sizes.max / 16;
    declarations[label] = (...args) => css`
      @media ${maxEmSize ? `(max-width: ${maxEmSize}em)` : ''} ${maxEmSize &&
        minEmSize
          ? 'and'
          : ''} ${minEmSize ? `(min-width: ${minEmSize}em)` : ''} {
        ${css(...args)}
      }
    `;
    return declarations;
  },
  {},
);

export function truncateWidth(width) {
  return `
    width: ${width};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `;
}

export const hexa = (hex, alpha) => {
  if (!hex) {
    return 'wfWhite';
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha >= 0) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
};
